import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ContextService } from './context.service';
import { isAiAllowed } from '../utils/ai-preference.util';

/**
 * One shared read of the "AI Preferences" switch (Configuration row Type=IsAIAllowed on the
 * current user), so every AI surface — the Mealy panel, its nav entry and route guard, Auto-fill
 * on the AP form — agrees on the same value instead of each re-reading `contextSvc.user` and
 * re-implementing the missing-row-means-allowed rule.
 */
@Injectable({ providedIn: 'root' })
export class AiPreferenceService {
  readonly allowed$: Observable<boolean>;

  constructor(private readonly contextSvc: ContextService) {
    this.allowed$ = this.contextSvc.user.pipe(
      map((user) => isAiAllowed(user?.configurations))
    );
  }

  /** Synchronous read for templates/guards that don't want to subscribe. */
  get allowed(): boolean {
    return isAiAllowed(this.contextSvc.user.value?.configurations) && this.contextSvc.isCompanyModuleActive('Ai');
  }
}
